import InteracHistoryList from '@src/components/InteracHistory/InteracHistoryList'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { useTranslation } from 'react-i18next'

const InteracHistoryListPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageHeader title={t('interacHistory.title')} breadcrumbs={{ current: t('interacHistory.title') }} />
      <PageContainer>
        <InteracHistoryList />
      </PageContainer>
    </>
  )
}

export default InteracHistoryListPage
